import React from 'react'
import { Box, Typography, Paper } from '@mui/material'
import { useTheme } from '@mui/material/styles'

interface AdSenseBannerProps {
    variant?: 'leaderboard' | 'large-banner' | 'medium-banner' | 'mobile-banner'
    position?: 'header' | 'footer' | 'content' | 'sidebar'
    responsive?: boolean
}

const AdSenseBanner: React.FC<AdSenseBannerProps> = ({
    variant = 'leaderboard',
    position = 'content',
    responsive = true
}) => {
    const theme = useTheme()

    const getDimensions = () => {
        switch (variant) {
            case 'leaderboard':
                return { width: 728, height: 90 }
            case 'large-banner':
                return { width: 970, height: 250 }
            case 'medium-banner':
                return { width: 468, height: 60 }
            case 'mobile-banner':
                return { width: 320, height: 50 }
            default:
                return { width: 728, height: 90 }
        }
    }

    const { width, height } = getDimensions()

    return (
        <Paper
            elevation={1}
            sx={{
                width: responsive ? { xs: '100%', sm: width } : width,
                height: responsive ? { xs: 'auto', sm: height } : height,
                minHeight: responsive ? { xs: 50, sm: height } : height,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: theme.palette.mode === 'dark' ? 'grey.800' : 'grey.100',
                border: `2px dashed ${theme.palette.mode === 'dark' ? 'grey.600' : 'grey.400'}`,
                borderRadius: 2,
                position: 'relative',
                overflow: 'hidden',
                mx: 'auto',
                my: 2,
                '&:hover': {
                    backgroundColor: theme.palette.mode === 'dark' ? 'grey.700' : 'grey.200',
                }
            }}
        >
            <Box sx={{ textAlign: 'center', p: 2 }}>
                <Typography
                    variant="caption"
                    sx={{
                        color: theme.palette.mode === 'dark' ? 'grey.400' : 'grey.600',
                        fontSize: '0.75rem',
                        fontWeight: 500
                    }}
                >
                    Google AdSense
                </Typography>
                <Typography
                    variant="caption"
                    sx={{
                        color: theme.palette.mode === 'dark' ? 'grey.500' : 'grey.500',
                        fontSize: '0.7rem',
                        display: 'block',
                        mt: 0.5
                    }}
                >
                    {width} × {height}
                </Typography>
                <Typography
                    variant="caption"
                    sx={{
                        color: theme.palette.mode === 'dark' ? 'grey.500' : 'grey.500',
                        fontSize: '0.65rem',
                        display: 'block',
                        mt: 0.5
                    }}
                >
                    {position} • {variant}
                </Typography>
                {responsive && (
                    <Typography
                        variant="caption"
                        sx={{
                            color: theme.palette.mode === 'dark' ? 'grey.500' : 'grey.500',
                            fontSize: '0.6rem',
                            display: 'block',
                            mt: 0.5
                        }}
                    >
                        responsive
                    </Typography>
                )}
            </Box>
        </Paper>
    )
}

export default AdSenseBanner
